module.exports = __webpack_public_path__ + "img/1024.ab674a59.svg";